import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const forgotPassword = async (email) => (await axios.post(`${API}/auth/forgot-password`, { email })).data;

export const resetPassword = async (token, new_password) => (await axios.post(`${API}/auth/reset-password`, { token, new_password })).data;
